module.exports = __webpack_public_path__ + "media/images/emailer-logo-f3d6382ff12272b5d1f19b05153113ee.png";